import React, { useState, useEffect, useRef } from 'react';
import { getServices, createService, updateService, deleteService, getStores } from '../api';
import Pagination from '../components/Pagination';

// 通用图标图库（9个图标，2个尺寸）
const ICON_LIBRARY = [
  { id: 1, web: 'https://img.shanxiaoqing.cn/images/service/icon-1-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-1-128.png' },
  { id: 2, web: 'https://img.shanxiaoqing.cn/images/service/icon-2-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-2-128.png' },
  { id: 3, web: 'https://img.shanxiaoqing.cn/images/service/icon-3-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-3-128.png' },
  { id: 4, web: 'https://img.shanxiaoqing.cn/images/service/icon-4-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-4-128.png' },
  { id: 5, web: 'https://img.shanxiaoqing.cn/images/service/icon-5-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-5-128.png' },
  { id: 6, web: 'https://img.shanxiaoqing.cn/images/service/icon-6-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-6-128.png' },
  { id: 7, web: 'https://img.shanxiaoqing.cn/images/service/icon-7-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-7-128.png' },
  { id: 8, web: 'https://img.shanxiaoqing.cn/images/service/icon-8-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-8-128.png' },
  { id: 9, web: 'https://img.shanxiaoqing.cn/images/service/icon-9-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-9-128.png' },
  { id: 10, web: 'https://img.shanxiaoqing.cn/images/service/icon-10-48.png', app: 'https://img.shanxiaoqing.cn/images/service/icon-10-128.png' },
];

// 每个类型对应的描述示例配置
const TYPE_CONFIG = {
  '护理服务': {
    descriptions: [
      '专业护理团队上门服务，提供伤口护理、输液护理、健康监测等服务',
      '为行动不便的患者提供专业上门护理，包括术后护理、慢性病管理、健康指导等',
      '资深护士提供一对一护理服务，确保专业、安全、贴心的护理体验'
    ]
  },
  '康复服务': {
    descriptions: [
      '专业康复师提供个性化康复训练，帮助恢复身体功能，提高生活质量',
      '针对术后、中风、运动损伤等情况，提供科学的康复治疗方案',
      '结合物理治疗、运动疗法，全面促进身体机能恢复'
    ]
  },
  '体检服务': {
    descriptions: [
      '全面健康体检，包括血常规、生化检查、影像检查等多项检测项目',
      '专业医师解读体检报告，提供健康指导和疾病预防建议',
      '便捷的上门体检服务，为您和家人的健康保驾护航'
    ]
  },
  '健康管理': {
    descriptions: [
      '个性化健康管理方案，包括饮食指导、运动计划、健康监测等服务',
      '专业健康管理师全程跟踪，帮助建立健康生活方式，预防疾病',
      '智能健康管理系统，实时监测健康数据，及时预警健康风险'
    ]
  },
  '理疗服务': {
    descriptions: [
      '传统中医理疗，包括艾灸、刮痧、拔罐、推拿等项目',
      '经验丰富的理疗师，根据个人体质提供个性化理疗方案',
      '结合传统中医理论，通过调理气血、疏通经络，达到养生保健效果'
    ]
  }
};

// JSON编辑器中常用的emoji列表
const JSON_EDITOR_EMOJIS = ['📌', '✅', '❌', '🔥', '🪨', '💆', '⚕️', '🌿', '💪', '⭐️', '❤️', '💯', '⏰', '📍', '🔔', '💡', '📋'];

// 理疗类型的详细描述JSON示例模板（包含所有12个支持的字段，包括新增的适合人群）
const THERAPY_JSON_TEMPLATE = {
  introduction: '📌【服务介绍】请在此处填写服务的详细介绍，包括服务原理、作用机制等',

  suitable_people: [
    '👥【适合人群】人群1：例如：体质虚弱、免疫力低下者',
    '👥 人群2：例如：手脚冰凉、畏寒怕冷者',
    '👥 人群3：例如：亚健康状态人群'
  ],

  benefits: [
    '✅【功效与好处】功效1：例如：温经散寒、活血化瘀',
    '💪 功效2：例如：增强体质、提升免疫力',
    '🌿 功效3：例如：调理气血、平衡阴阳'
  ],

  acupoints: [
    '📍【穴位列表】穴位1：例如：关元穴（位于下腹部，脐下3寸）',
    '📍 穴位2：例如：气海穴（位于下腹部，脐下1.5寸）',
    '📍 穴位3：例如：足三里（位于小腿前外侧，当犊鼻下3寸）'
  ],

  areas: [
    '📍【推荐部位】部位1：例如：腹部（以肚脐为中心）',
    '📍 部位2：例如：背部（沿脊柱两侧）',
    '📍 部位3：例如：四肢（手臂和腿部）'
  ],

  method: '🔧【操作方法】例如：使用艾条悬灸，每穴位悬灸10-15分钟，以皮肤温热发红为度',

  duration: '⏰【服务时长】例如：每次30-45分钟',

  frequency: '🔔【建议频次】例如：每周2-3次，10次为一个疗程',

  usage_guide: '📖【使用指导】例如：治疗前请排空膀胱，穿着宽松衣物，治疗后避免立即洗澡',

  precautions: [
    '⚠️【注意事项】注意事项1：例如：空腹或过饱不宜进行',
    '⚠️ 注意事项2：例如：孕妇及月经期女性慎用',
    '⚠️ 注意事项3：例如：术后恢复期需医生指导'
  ],

  indications: [
    '💡【适应症】适应症1：例如：虚寒性胃痛、腹痛',
    '💡 适应症2：例如：手脚冰凉、体质虚弱',
    '💡 适应症3：例如：疲劳乏力、免疫力低下'
  ]
};

function Services() {
  const user = JSON.parse(sessionStorage.getItem('health_user') || '{}');
  const isAdmin = user?.role === 'admin';
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState('全部');
  const [storeFilter, setStoreFilter] = useState('');
  const [stores, setStores] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 20, total: 0, totalPages: 0 });
  const [sortInfo, setSortInfo] = useState({ field: 'id', order: 'asc' });
  const [formData, setFormData] = useState({ name: '', type: '', price: '', description: '', store_id: '', category: '', icon_web: '', icon_app: '', rich_description: '', therapy_type: '', body_types: '' });
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [showJsonHelp, setShowJsonHelp] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const richDescRef = useRef(null);

  const types = ['全部', '理疗服务', '护理服务', '康复服务', '体检服务', '健康管理'];

  useEffect(() => { fetchStores(); }, []);
  useEffect(() => { fetchServices(); }, [filterType, storeFilter, pagination.page, pagination.pageSize, sortInfo]);

  const fetchStores = async () => {
    if (!isAdmin) return;
    try {
      const res = await getStores();
      if (res.data.success) setStores(res.data.data);
    } catch (e) { console.error(e); }
  };

  const fetchServices = async () => {
    try {
      setLoading(true);
      const res = await getServices({
        type: filterType === '全部' ? '' : filterType,
        store_id: storeFilter || undefined,
        page: pagination.page,
        pageSize: pagination.pageSize,
        sortBy: sortInfo.field,
        sortOrder: sortInfo.order
      });
      if (res.data.success) {
        setServices(res.data.data);
        if (res.data.pagination) setPagination(prev => ({ ...prev, ...res.data.pagination }));
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handlePageChange = (page) => setPagination(prev => ({ ...prev, page }));
  const handlePageSizeChange = (pageSize) => setPagination(prev => ({ ...prev, pageSize, page: 1 }));
  const handleSortChange = (field, order) => setSortInfo({ field, order });

  // 当类型改变时，自动设置描述和对应的分类
  const handleTypeChange = (newType) => {
    // 层级选择逻辑：根据类型自动设置分类
    let autoCategory = '';
    if (newType === '理疗服务') {
      autoCategory = 'therapy'; // 理疗服务只能选择"理疗服务"分类
    } else if (newType && newType !== '') {
      autoCategory = 'general'; // 其他服务只能选择"常规服务"分类
    }

    // 直接设置所有字段，不要分开设置
    setFormData({
      ...formData,
      type: newType,
      category: autoCategory,
      therapy_type: '' // 切换类型时清空理疗类型
    });

    if (newType && TYPE_CONFIG[newType]) {
      const config = TYPE_CONFIG[newType];
      // 如果描述为空，自动设置第一个描述
      if (!formData.description) {
        setTimeout(() => {
          setFormData(prev => ({ ...prev, description: config.descriptions[0] }));
        }, 0);
      }
    }
  };

  // 选择图标
  const handleSelectIcon = (iconItem) => {
    setFormData({ ...formData, icon_web: iconItem.web, icon_app: iconItem.app });
    setShowIconPicker(false);
  };

  // 插入emoji到JSON描述中
  const handleInsertEmoji = (emoji) => {
    const textarea = richDescRef.current;
    if (!textarea) return;

    const currentValue = formData.rich_description || '';
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    const newValue =
      currentValue.substring(0, startPos) +
      emoji +
      currentValue.substring(endPos);

    setFormData({ ...formData, rich_description: newValue });

    // 设置新的光标位置
    setTimeout(() => {
      textarea.focus();
      const newCursorPos = startPos + emoji.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editItem) await updateService(editItem.id, formData);
      else await createService(formData);
      setShowModal(false);
      resetForm();
      fetchServices();
    } catch (e) {
      alert(e.response?.data?.message || e.message);
    }
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setFormData({ name: item.name, type: item.type || '', price: item.price || '', description: item.description || '', store_id: item.store_id || '', category: item.category || '', icon_web: item.icon_web || '', icon_app: item.icon_app || '', rich_description: item.rich_description || '', therapy_type: item.therapy_type || '', body_types: item.body_types || '' });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定删除?')) {
      try { await deleteService(id); fetchServices(); } catch (e) { alert(e.response?.data?.message || '删除失败'); }
    }
  };

  const resetForm = () => { setEditItem(null); setFormData({ name: '', type: '', price: '', description: '', store_id: '', category: '', icon_web: '', icon_app: '', rich_description: JSON.stringify(THERAPY_JSON_TEMPLATE, null, 2), therapy_type: '', body_types: '' }); };

  return (
    <div className="content-card">
      <div className="section-title">服务项目管理</div>

      <div style={{ marginBottom: 12 }}>
        <button className="action-btn btn-blue" onClick={() => { resetForm(); setShowModal(true); }}>+ 新增服务</button>
      </div>

      <div className="filter-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <select className="filter-select" value={filterType} onChange={e => { setFilterType(e.target.value); setPagination(p => ({ ...p, page: 1 })); }}>
            {types.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          {isAdmin && (
            <select className="filter-select" value={storeFilter} onChange={e => { setStoreFilter(e.target.value); setPagination(p => ({ ...p, page: 1 })); }}>
              <option value="">全部门店</option>
              {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          )}
        </div>
      </div>

          {loading ? <div className="loading-text">加载中...</div> : (
            <>
              <table className="basic-table">
                <thead>
                  <tr>
                    <th className="no-cell">序号</th>
                    <th>门店</th>
                    <th onClick={() => handleSortChange('name', sortInfo.field === 'name' ? (sortInfo.order === 'asc' ? 'desc' : 'asc') : 'asc')} style={{cursor:'pointer'}}>服务名称{sortInfo.field==='name' && <span>{sortInfo.order==='asc'?'↑':'↓'}</span>}</th>
                    <th>类型</th>
                    <th onClick={() => handleSortChange('price', sortInfo.field === 'price' ? (sortInfo.order === 'asc' ? 'desc' : 'asc') : 'asc')} style={{cursor:'pointer'}}>价格{sortInfo.field==='price' && <span>{sortInfo.order==='asc'?'↑':'↓'}</span>}</th>
                    <th>描述</th><th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {services.length > 0 ? services.map((s, i) => (
                    <tr key={s.id}>
                      <td className="no-cell">{i + 1}</td><td>{s.store_name || '-'}</td><td>{s.name}</td><td>{s.type || '-'}</td><td>¥{s.price}</td><td>{(s.description || s.rich_description || '-').replace(/[)"}]/g, '').substring(0, 30)}</td>
                      <td><button className="btn-xs btn-blue" onClick={() => handleEdit(s)}>编辑</button><button className="btn-xs btn-red" onClick={() => handleDelete(s.id)}>删除</button></td>
                    </tr>
                  )) : <tr><td colSpan="7" style={{textAlign:'center',color:'#999'}}>暂无数据</td></tr>}
                </tbody>
              </table>
              <Pagination pagination={pagination} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} />
            </>
          )}

      {showModal && (
        <div className="modal-mask">
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-title"><span>{editItem ? '编辑服务' : '新增服务'}</span><span className="modal-close" onClick={() => setShowModal(false)}>×</span></div>
            <form onSubmit={handleSubmit}>
              <div className="modal-content">
                <div className="form-tip">带 <span style={{color:'#ff4d4f'}}>*</span> 号的为必填项</div>

                {/* 基本信息卡片 */}
                <div className="form-card">
                  <div className="form-card-title">📋 基本信息</div>
                  {isAdmin && (
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">门店</label>
                        <select className="form-input" value={formData.store_id} onChange={e => setFormData({...formData, store_id: e.target.value})}>
                          <option value="">请选择</option>
                          {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className="form-row">
                    <div className="form-field" style={{flex:2}}>
                      <label className="form-label">服务名称 *</label>
                      <input className="form-input" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="请输入服务名称" required />
                    </div>
                    <div className="form-field" style={{flex:1}}>
                      <label className="form-label">类型</label>
                      <select className="form-input" value={formData.type} onChange={e => handleTypeChange(e.target.value)}>
                        <option value="">请选择</option>
                        {types.slice(1).map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label className="form-label">分类</label>
                      <select className="form-input" value={formData.category} disabled>
                        <option value="">请选择</option>
                        <option value="general" disabled={formData.type === '理疗服务'}>常规服务</option>
                        <option value="therapy" disabled={formData.type !== '理疗服务' && formData.type !== ''}>理疗服务</option>
                      </select>
                      {formData.type && (
                        <div className="form-help-text">
                          {formData.type === '理疗服务' ? '理疗服务类型自动选择"理疗服务"分类' : '其他服务类型自动选择"常规服务"分类'}
                        </div>
                      )}
                    </div>
                    <div className="form-field">
                      <label className="form-label">价格</label>
                      <input className="form-input" type="number" value={formData.price} onChange={e => setFormData({...formData, price: e.target.value})} placeholder="价格" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label className="form-label">服务图标</label>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        {formData.icon_web && (
                          <img src={formData.icon_web} alt="已选图标" style={{ width: '32px', height: '32px', borderRadius: '4px', border: '1px solid #ddd' }} />
                        )}
                        <button type="button" className="btn-xs btn-blue" onClick={() => setShowIconPicker(!showIconPicker)}>{formData.icon_web ? '更换' : '选择'}</button>
                      </div>
                      {showIconPicker && (
                        <div style={{ border: '1px solid #ddd', marginTop: '10px', padding: '10px', borderRadius: '8px', backgroundColor: '#fafafa' }}>
                          <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>点击选择图标：</div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {ICON_LIBRARY.map((item) => (
                              <button
                                key={item.id}
                                type="button"
                                onClick={() => handleSelectIcon(item)}
                                style={{ padding: '4px', border: formData.icon_web === item.web ? '2px solid #1890ff' : '1px solid #ddd', borderRadius: '6px', cursor: 'pointer', background: '#fff' }}
                              >
                                <img src={item.web} alt={`图标${item.id}`} style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* 理疗设置卡片 */}
                {formData.category === 'therapy' && (
                  <div className="form-card">
                    <div className="form-card-title">🏥 理疗设置</div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">理疗类型</label>
                        <select className="form-input" value={formData.therapy_type} onChange={e => setFormData({...formData, therapy_type: e.target.value})}>
                          <option value="">请选择</option>
                          <option value="moxibustion">艾灸</option>
                          <option value="scraping">刮痧</option>
                          <option value="acupoint">穴位调理</option>
                          <option value="massage">推拿按摩</option>
                          <option value="cupping">拔罐</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">适合体质</label>
                        <input className="form-input" value={formData.body_types} onChange={e => setFormData({...formData, body_types: e.target.value})} placeholder="如：痰湿体质,气虚体质" />
                      </div>
                    </div>
                  </div>
                )}

                {/* 详细描述卡片 */}
                {formData.category === 'therapy' && (
                  <div className="form-card">
                    <div className="form-card-title">💬 详细描述 (JSON格式)</div>
                    <div className="form-row">
                      <div className="form-field">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label className="form-label" style={{ margin: 0 }}>JSON详细描述</label>
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <button type="button" className="btn-xs btn-green" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>插入图标</button>
                              <button type="button" className="btn-xs btn-blue" onClick={() => setShowJsonHelp(!showJsonHelp)}>格式帮助</button>
                            </div>
                          </div>
                          <textarea
                            className="json-input"
                            rows={10}
                            value={formData.rich_description}
                            onChange={e => setFormData({...formData, rich_description: e.target.value})}
                            placeholder='{"introduction":"服务介绍...","benefits":["功效1","功效2"],"acupoints":["穴位1","穴位2"]}'
                            ref={richDescRef}
                          />
                          {showEmojiPicker && (
                            <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '12px', backgroundColor: '#fafafa' }}>
                              <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px', fontWeight: '500' }}>🎯 点击图标插入到JSON中：</div>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                {JSON_EDITOR_EMOJIS.map((emoji, idx) => (
                                  <button key={idx} type="button" onClick={() => handleInsertEmoji(emoji)} style={{ fontSize: '20px', padding: '6px 10px', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer', background: '#fff', transition: 'all 0.2s', ':hover': { background: '#f0f0f0' } }}>{emoji}</button>
                                ))}
                              </div>
                            </div>
                          )}
                          {showJsonHelp && (
                            <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '16px', backgroundColor: '#f8f9fa' }}>
                              <div style={{ fontSize: '14px', color: '#333', marginBottom: '12px', fontWeight: 'bold' }}>📋 JSON格式示例：</div>
                              <pre style={{ fontSize: '13px', lineHeight: '1.5', color: '#555', margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'monospace' }}>{JSON.stringify(THERAPY_JSON_TEMPLATE, null, 2)}</pre>
                              <div style={{ fontSize: '12px', color: '#999', marginTop: '12px', fontStyle: 'italic' }}>💡 提示：请根据实际服务内容修改上述示例中的字段。使用时请删除【】及其中的说明内容，保留实际的服务信息即可。</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 服务描述卡片 */}
                <div className="form-card">
                  <div className="form-card-title">📝 服务描述</div>
                  <div className="form-row">
                    <div className="form-field">
                      <textarea className="form-input" rows={4} value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} placeholder="请输入服务描述（简短介绍）" style={{ resize: 'vertical' }} />
                    </div>
                  </div>
                </div>

              </div>
              <div className="modal-foot">
                <button type="button" onClick={() => setShowModal(false)}>取消</button>
                <button type="submit" className="action-btn btn-blue">保存</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Services;